<template>
  <!-- wrap the built-in Transition component -->
  <Transition
    name="sales-floor-widget-transition"
    :css="false"
    appear
    @enter="onEnter"
    @after-enter="onAfterEnter"
    @after-leave="onAfterLeave"
    @leave="onLeave"
  >
    <slot>
      <!-- pass down slot content -->
    </slot>
  </Transition>
</template>

<script setup>

import {
  ref, computed, provide, watch, readonly,
} from 'vue';
import { DomHandler } from 'primevue/utils';

const fadeIn = ref(true);
const transitionType = ref('fade-in');
const isMounted = ref(false);
const isInTransition = computed(() => !!transitionType.value.length);
const fadeDuration = computed(() => (isMounted.value ? 300 : 500));

provide('fadeIn', readonly(fadeIn));
provide('transitionData', { transitionType, isInTransition });

const onEnter = (el, done) => {
  DomHandler.fadeIn(el, fadeDuration.value);
  done();
};

const onAfterEnter = () => {
  if (!isMounted.value) {
    isMounted.value = true;
  }
  if (transitionType.value === 'fade-out-in' || transitionType.value === 'fade-in') {
    transitionType.value = '';
  }
};

const onLeave = (el, done) => {
  DomHandler.fadeOut(el, fadeDuration.value);
  done();
};

const onAfterLeave = () => {
  if (!fadeIn.value && transitionType.value === 'fade-out-in') {
    fadeIn.value = true;
  }
};

watch(transitionType, (transition) => {
  if (transition.length) {
    fadeIn.value = !!transition.includes('fade-in');
  }
});
</script>
